import React from "react";
import Modal from "react-bootstrap/Modal";
import { StCloseButton } from "./StCloseButton";
import { useTranslation } from "react-i18next";
import Ownership from "./Ownership";

function OwnershipModal(props) {
  const { productData, isShowModal, closeModal } = props;
  const { t } = useTranslation("common");

  const handleClose = () => {
    closeModal();
  };

  return (
    <>
      <Modal
        size="md"
        centered={true}
        backdrop="static"
        show={isShowModal}
        onHide={handleClose}
      >
        <Modal.Header>
          <div style={{ position: "absolute", right: 10 }}>
            <StCloseButton
              text={t("Close")}
              onClick={() => handleClose()}
            ></StCloseButton>
          </div>
        </Modal.Header>
        <Modal.Body style={{ fontWeight: "normal" }}>
          <Ownership productData={productData} handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default OwnershipModal;
